export default __webpack_public_path__ + "static/image4-e44b24c4f3b5aa3a61a21972d01c3999.gif";